import type { ReduxState } from '@/redux/app/state';

export const tcrBrandSelector = (state: ReduxState) =>
  state.tcr.brand;

export const tcrBrandStatusSelector = (state: ReduxState) =>
  state.tcr.brandStatus;

export const tcrBrandMessageSelector = (state: ReduxState) =>
  state.tcr.brandMessage;

export const tcrBrandUpdateStatusSelector = (state: ReduxState) =>
  state.tcr.brandUpdateStatus;

export const tcrBrandUpdateMessageSelector = (state: ReduxState) =>
  state.tcr.brandUpdateMessage;

export const vetTcrBrandStatusSelector = (state: ReduxState) =>
  state.tcr.vetBrandStatus;

export const vetTcrBrandMessageSelector = (state: ReduxState) =>
  state.tcr.vetBrandMessage;

export const resubmitTcrBrandStatusSelector = (state: ReduxState) =>
  state.tcr.resubmitBrandStatus;

export const resubmitTcrBrandMessageSelector = (state: ReduxState) =>
  state.tcr.resubmitBrandMessage;

export const tcrLoadingStatusSelector = (state: ReduxState) =>
  state.tcr.loadingStatus;

export const tcrCampaignsOrderSelector = (state: ReduxState) =>
  state.tcr.campaignsOrder;

export const tcrCampaignsSelector = (state: ReduxState) =>
  state.tcr.campaigns;

export const tcrCampaignStatusSelector = (state: ReduxState) =>
  state.tcr.campaignStatus;

export const tcrCampaignMessageSelector = (state: ReduxState) =>
  state.tcr.campaignMessage;

export const updateTcrCampaignStatusSelector = (state: ReduxState) =>
  state.tcr.updateCampaignStatus;

export const updateTcrCampaignMessageSelector = (state: ReduxState) =>
  state.tcr.updateCampaignMessage;

export const archiveTcrCampaignStatusSelector = (state: ReduxState) =>
  state.tcr.archiveCampaignStatus;

export const archiveTcrCampaignMessageSelector = (state: ReduxState) =>
  state.tcr.archiveCampaignMessage;

export const tcrCreateExternalCampaignStatusSelector = (state: ReduxState) =>
  state.tcr.createExternalCampaignStatus;

export const tcrCreateExternalCampaignMessageSelector = (state: ReduxState) =>
  state.tcr.createExternalCampaignMessage;

export const tcrNotificationSelector = (state: ReduxState) =>
  state.tcr.notification;

export const tcrUnsyncedAccountsSelector = (state: ReduxState) =>
  state.tcr.unsyncedAccounts;

export const tcrUnsyncInboxStatusSelector = (state: ReduxState) =>
  state.tcr.unsyncInboxStatus;

export const tcrUnsyncInboxMessageSelector = (state: ReduxState) =>
  state.tcr.unsyncInboxMessage;

export const tcrMessageFlowAnswersSelector = (state: ReduxState) =>
  state.tcr.messageFlowMap;

export const tcrNudgeTcrCampaignMessageSelector = (state: ReduxState) =>
  state.tcr.nudgeTcrCampaignMessage;

export const tcrNudgeTcrCampaignStatusSelector = (state: ReduxState) =>
  state.tcr.nudgeTcrCampaignStatus;

export const tcrByotSelector = (state: ReduxState) =>
  state.tcr.byot;
